import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Genre from '@/components/screens/genre/Genre';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import { IGenreBooksPage } from '@/interfaces/genreBooksPage.interface';
import { IZhanr } from '@/interfaces/zhanr.interface';

interface IZhanrPageDynamicProps {
  books: IGenreBooksPage;
  genres: IZhanr;
  freeBooks: boolean;
}

const ZhanrPageDynamic: NextPage<IZhanrPageDynamicProps> = ({ books, genres, freeBooks }) => {
  return <Genre books={books} genres={genres} freeBooks={freeBooks} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias, free_books, page } = context.query;

  const [booksRes, genresRes] = await Promise.all([fetch(`${API_URL}genres/books/${alias}?${!!free_books ? `free_book=true&` : ``}page=${page ? page : `1`}&page_size=${BOOKS_FOR_PAGE}`), fetch(`${API_URL}satellite/genres/genre/${alias}`)]);

  // Check fetch error
  if (!booksRes.ok) {
    console.table(`Error ${booksRes.status}. Api: ${booksRes.url}`);
    return {
      notFound: true,
    };
  }

  const [books, genres] = await Promise.all([booksRes.json(), genresRes.json()]);

  const freeBooks = !!free_books;

  return { props: { books, genres, freeBooks } };
};

export default ZhanrPageDynamic;
